/**
 * 動画ページのモーダル
 * @constructor
 */
class ModalMovie {
  constructor() {
  }
  /**
   * 動画ページのモーダル
   */
  init() {
    const self = this;

    $(function () {
      let scrollpos,
          srcUrl;
      $('.js-openModal').on('click', function () { //モーダル開く
        let num = $(this).data('modal');
        if ($(this).attr('data-movie')) {
          let srcUrlBVal = $(this).attr('data-movie');
          srcUrl = `https://www.youtube.com/embed/${srcUrlBVal}?rel=0`;
          // srcUrl = 'https://www.youtube.com/embed/_dsNe5jr5LY?rel=0'
        } else {
          srcUrl = 'https://www.youtube.com/embed/Vpf1qG9IzDU?rel=0';
        }
        $('.m-modalCt').css('display', 'block');
        $('#youtube').attr('src', srcUrl);
        $('#modal_' + num).css('display', 'block');
        $('.js-modal').fadeIn(200);
        scrollpos = $(window).scrollTop();
        $('body').addClass('fixed').css({
          'top': -scrollpos,
          'right': 0,
          'left': 0
        });
        return false;
      })
      $('.js-closeModal,.m-modal__bg').on('click', function () { // モーダル閉じる
        $('.js-modal').fadeOut(200, function () {
          $('.js-modal').css('display', 'none');
          $('.m-modalCt').css('display', 'none');
          $('.m-modalCt__item').css('display', 'none');
          $('#youtube').attr('src', '');
          $('body').removeClass('fixed').css({
            'top': 0
          });
          $('html,body').animate({
            scrollTop: scrollpos
          }, 0);
          srcUrl = '';
        });
      })
    })

  }


}

export default ModalMovie;
